<template>
  <v-row>
    <v-col cols="12 pt-0">
      <Title
        text-start
        :font-weight="600"
        :font-size="14"
        title="Документ удостоверяющий личность"
        append-icon="mdi-trash-can-outline"
        @click:append-outer="removeIdentityCard"
      />
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="identityCard.citizenship"
        :items="dictionaries.country"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setIdentityCard"
      >
        <template #label>
          <span class="required">Гражданство</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-show="!showIdentityCardDocTypeName"
        v-model="identityCard.identityCardDocType"
        :items="dictionaries.identityCardDocType"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        persistent-hint
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        hint="Если вы не нашли тип документа в выпадающем списке, введите название вручную, нажав на карандаш"
        append-outer-icon="mdi-pencil-outline"
        @click:append-outer="changeShowIdentityCardDocTypeName"
        return-object
        @input="setIdentityCard"
      >
        <template #label>
          <span class="required">Тип документа</span>
        </template>
      </v-autocomplete>

      <v-text-field
        v-show="showIdentityCardDocTypeName"
        v-model="identityCard.identityCardDocTypeName"
        placeholder="Введите данные"
        rounded outlined dense
        append-outer-icon="mdi-pencil-outline"
        @click:append-outer="changeShowIdentityCardDocTypeName"
        @input="setIdentityCard"
      >
        <template #label>
          <span class="required">Тип документа</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <v-text-field
        v-model="identityCard.series"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setIdentityCard"
      >
        <template #label>
          <span class="required">Серия</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <v-text-field
        v-model="identityCard.number"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setIdentityCard"
      >
        <template #label>
          <span class="required">Номер</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <DatePicker
        label="Дата выдачи"
        required
        :prop-date="identityCard.issueDate"
        @set-date="setIssueDate"
      />
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-text-field
        v-model="identityCard.issueBy"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setIdentityCard"
      >
        <template #label>
          <span class="required">Кем выдан</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" class="pt-0">
      <FileInput
        title="Файл документа удостоверяющего личность"
        :ref-id="identityCard?.id"
        ref-class-name="IdentityCard"
        @set-files="setFiles"
      />
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import DatePicker from '@/components/ui/DatePicker'
import FileInput from '@/components/ui/FileInput'
import {IdentityCard} from "@/models"
import {mapGetters} from "vuex";

export default {
  name: "IdentityCard",

  components: {
    Title,
    DatePicker,
    FileInput
  },

  props: {
    item: IdentityCard
  },

  data: () => ({
    identityCard: new IdentityCard(),
    showIdentityCardDocTypeName: false
  }),

  computed: {
    ...mapGetters('dictionaries', ['dictionaries'])
  },

  methods: {
    changeShowIdentityCardDocTypeName() {
      this.showIdentityCardDocTypeName = !this.showIdentityCardDocTypeName
      this.showIdentityCardDocTypeName ? this.identityCard.identityCardDocType = null
        : this.identityCard.identityCardDocTypeName = null
      this.setIdentityCard()
    },

    setIdentityCard() {
      this.$emit('set-data', this.identityCard)
    },

    removeIdentityCard() {
      this.$emit('remove', this.identityCard)
    },

    setIssueDate(value) {
      this.identityCard.issueDate = value
      this.setIdentityCard()
    },

    setFiles(value) {
      this.identityCard.filesData = value
      this.setIdentityCard()
    }
  },

  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler() {
        this.identityCard = IdentityCard.build(this.item)
        if (!this.identityCard.identityCardDocType?.id && this.identityCard.identityCardDocTypeName) {
          this.showIdentityCardDocTypeName = true
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
